import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CrossButton } from '@/icons';
import React from 'react';
var GenericModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children;
    if (!isOpen)
        return null;
    return (_jsx("div", { className: 'fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-100051 ', children: _jsxs("div", { className: 'bg-white rounded-[20px] shadow-lg w-[1200px] h-[700px] max-w-full max-h-full overflow-auto p-5 relative m-[50px] scrollbar-hide', children: [_jsx("button", { onClick: onClose, className: 'absolute bg-transparent top-6 right-2 text-gray-500 hover:text-gray-800 transition', children: _jsx(CrossButton, {}) }), children] }) }));
};
export default GenericModal;
